import { CSmartTable } from './CSmartTable.js';

const CSmartTablePlugin = {
    install: (app) => {
        app.component(CSmartTable.name, CSmartTable);
    },
};

export { CSmartTable, CSmartTablePlugin };
//# sourceMappingURL=index.js.map
